<script lang="ts">
    export let title: string = '';
    export let copyright: string = '';
    export let url: string = '';
    export let srcset: string = '';
    export let width: number;
    export let height: number;
</script>

<figure class="relative m-0 h-full">
    <img
        class="h-full w-full object-contain"
        src={url}
        {srcset}
        alt={title}
        style:object-fit={width >= height ? 'cover' : 'contain'}
        {width}
        {height}
        loading="lazy"
    />
</figure>
